import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"

const oneHour = 1000 * 60 * 60

export function useEnvironment() {
  const data = useSuspenseQueryGet("/api/Environment", null, {
    staleTime: oneHour,
    gcTime: oneHour,
  })
  return data.data
}
